// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const TopicSummary = () => ({
   replace: true,
   templateUrl: '/assets/topicSummary.html',
   controller: 'TopicCtrl',
   controllerAs: 'vm',

   bindToController: {
      fromSearchInfo: '<'
   }
})

angular.module('summonApp.directives')
   .directive('topicSummary', TopicSummary)
